import type { ReactNode } from "react";

interface ToolbarProps {
  children: Readonly<ReactNode>;
}

export default function Toolbar({ children }: ToolbarProps) {
  return (
    <header className="sticky top-0 right-0 left-0 z-40 overflow-hidden backdrop-blur-md">
      <nav className="flex h-18 w-full items-center justify-center py-4 md:justify-between">
        {children}
      </nav>
    </header>
  );
}
